import type { TodayPracticeCard as PracticeCardData } from '@/types/api';
import { cls } from '@/lib/format';

export function PracticeCard({ card }: { card: PracticeCardData }) {
  const title = card.title && card.title.length > 0 ? card.title : 'Practice session';
  return (
    <article className="flex flex-col gap-1 rounded-xl bg-[var(--color-secondary-bg)] px-4 py-3">
      <div className="flex items-center justify-between">
        <h3 className="font-medium text-[var(--color-fg)]">{title}</h3>
        <span
          className={cls(
            'rounded-full px-2 py-0.5 text-xs',
            card.status === 'done'
              ? 'bg-green-500/20 text-green-600 dark:text-green-400'
              : card.status === 'skipped'
                ? 'bg-amber-500/20 text-amber-600 dark:text-amber-400'
                : 'bg-[var(--color-button)]/15 text-[var(--color-accent)]',
          )}
        >
          {card.status}
        </span>
      </div>
      {card.description ? (
        <p className="line-clamp-2 text-sm text-[var(--color-muted)]">{card.description}</p>
      ) : null}
      <div className="flex items-center gap-3 text-xs text-[var(--color-muted)]">
        <span>{card.duration_min} min</span>
        <span>·</span>
        <span className="capitalize">{card.source}</span>
      </div>
    </article>
  );
}
